import React, { useState } from 'react';
import { toast } from 'react-toastify';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import PrintIcon from '@mui/icons-material/Print';

// import JS files
import PanelTable from '../../../shares/PanelTable';
import MuiPagination from '../../../shares/MuiPagination';
import OrderDetails from './OrderDetails';
import useFetch from '../../../../context/useFetch';
import PanelFilter from '../../../shares/PanelFilter';
import PanelTemplate from '../../../shares/PanelTemplate';
import { fixNumbers } from '../../../../utils';
import MuiButton from '../../../shares/MuiButton';
import { useNavigate } from 'react-router-dom';
import AdminPrintRemoveOrderiInfo from './AdminPrintRemoveOrderiInfo';

const headersList = [
  { colName: 'code', name: 'سند ' },
  { colName: 'name', name: 'مشتری' },
  { colName: 'date', name: 'تاریخ ثبت سفارش' },
  { colName: 'details', name: 'جزییات سفارش' },
  { colName: 'print', name: 'چاپ سفارش' },
];
const dataKey = ['unique_id', 'name', 'created_at'];
const mobileHeadersList = [
  { colName: 'name', name: 'مشتری' },
  { colName: 'code', name: ' سند' },
  { colName: 'date', name: 'تاریخ ثبت سفارش' },
];

const CustomerRemovedOrders = (props) => {
  const navigate = useNavigate();
  const [codeFilter, setCodeFilter] = useState(null);
  const [dateFilter, setDateFilter] = useState(null);
  const [customerFilter, setCustomerFilter] = useState(null);
  const [isFilterOn, setIsFilterOn] = useState(false);
  const [selectedRow, setSelectedRow] = useState(undefined);

  const filterList = [
    {
      type: 'textField',
      label_fa: 'کد سفارش',
      label_en: 'code',
      state: codeFilter,
    },
    {
      type: 'textField',
      label_fa: 'مشتری',
      label_en: 'customerName',
      state: customerFilter,
    },
    {
      type: 'datePicker',
      label_fa: 'تاریخ ثبت سفارش',
      label_en: 'date',
      state: dateFilter,
    },
  ];

  const [paginationPageInfo, setPaginationPageInfo] = useState({
    current: 1,
    pageSize: 30,
    count: 0,
  });

  const [removedOrdersList, setRemovedOrdersList] = useState({ results: [] });

  const adminGetCustomerRemovedOrderApi = useFetch({
    method: 'get',
    url: `Order_Service/admin_get_cancel_order`,
    params: {
      unique_id: fixNumbers(codeFilter),
      date: dateFilter,
      name: customerFilter,
    },
    trigger: true,
    pagination: paginationPageInfo,
    setter: setRemovedOrdersList,
    argFunc: (res) => {
      setPaginationPageInfo({
        current: res.current,
        pageSize: res.pageSize,
        count: res.count,
        next: res.next,
        previous: res.previous,
      });
    },
    errMessage: (mess) => {
      toast.error('خطایی رخ داده است', {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  const update_filter = (state, e) => {
    if (state == 'code') setCodeFilter(e.length > 0 ? e : null);
    if (state == 'date') setDateFilter(e.length > 0 ? e : null);
    if (state == 'customerName') setCustomerFilter(e.length > 0 ? e : null);
  };
  const filter = () => {
    if (codeFilter !== null || dateFilter !== null || customerFilter !== null) {
      setIsFilterOn(true);
      adminGetCustomerRemovedOrderApi.reFetch();
    }
  };
  const reset_filter = () => {
    setCodeFilter(null);
    setDateFilter(null);
    setCustomerFilter(null);
    adminGetCustomerRemovedOrderApi.reFetch();
  };

  const actionsList = [
    {
      label: 'چاپ',
      component: (it) => <AdminPrintRemoveOrderiInfo selectedRow={it} />,
    },
  ];

  const buttonsList = [
    {
      label: 'جزییات سفارش',
      component: (it) => (
        <OrderDetails
          RemoveOrder
          selectedRow={it}
          adminGetCustomerRemovedOrderApi={adminGetCustomerRemovedOrderApi}
        />
      ),
    },
  ];

  const onChangePage = (e, page) => {
    setPaginationPageInfo({
      ...paginationPageInfo,
      current: page,
    });
    // setRemovedOrdersList({ results: [] });x
    adminGetCustomerRemovedOrderApi.reFetch();
  };

  const handelPrintReport = () => {
    // navigate(
    //   `/print-customers-removed-orders/${codeFilter}/${customerFilter}/${dateFilter}`
    // );
    window.open(
      `/print-customers-removed-orders/${codeFilter}/${customerFilter}/${dateFilter}`,
      "_blank"
      // "rel=noopener noreferrer"
    );
  };

  return (
    <>
      <PanelTemplate sidebarActiveLink="c-cancelled-orders">
        <>
          <div className="panel-main-header">
            <span>سفارش‌های لغو شده</span>
          </div>
          <PanelFilter
            header="فیلتر سفارش‌ها:"
            list={filterList}
            update_filter={update_filter}
            filter={filter}
            reset_filter={reset_filter}
          />
          <div className="flex justify-end">
            <MuiButton
              onClick={handelPrintReport}
              variant="outlined"
              icon={<PrintIcon />}
              color="primary"
              text="چاپ گزارش"
              margin="mr-2"
            />
          </div>
          <PanelTable
            header="لیست سفارش‌های لغو شده:"
            headers={headersList}
            mobileHeaders={mobileHeadersList}
            data={removedOrdersList.results}
            dataKey={dataKey}
            buttons={buttonsList}
            actions={actionsList}
            icon={<AccountBalanceIcon />}
          />
          <MuiPagination
            onChange={onChangePage}
            count={Math.ceil(
              paginationPageInfo.count / paginationPageInfo.pageSize
            )}
          />
        </>
      </PanelTemplate>
    </>
  );
};

export default CustomerRemovedOrders;
